export const baseWidgetUrl = 'https://buy.ramp.network/';

export const SEND_CRYPTO_SUPPORTED_VERSION = 1 as const;
